(() => {
  const targetElementToObserve = document.querySelector('.js-resize-observer-target');
  const targetElementToSetHeight = document.querySelector('.js-resize-observer-target-wrapper');
  const observer = new ResizeObserver((entries) => {
    if (!targetElementToSetHeight) {
      return;
    }
    targetElementToSetHeight.style.height = `${entries[0].contentRect.height}px`;
  });
  if (targetElementToObserve) {
    observer.observe(targetElementToObserve, { box : 'border-box' });
  }
})();


